import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';
import { Button, HeadingFive, Card } from 'hui/src/styled';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import { CategoryType } from '../types';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import { trackEvent } from '../../../utils/googleAnalytics';
import CustomQuestionsModal from '../CustomQuestionsModal';

const QuestionStep = ({ question, onSubmit, answered, selectedCategory, category }) => (
  <Form onSubmit={onSubmit} style={fillContainer}>
    <Card m={0} p={1} center style={fillContainer}>
      <HeadingFive mb={2}>{question.name}</HeadingFive>
      <CustomQuestionsModal
        stacked
        disableLabels={true}
        questions={[question]}
        answered={answered}
        onChange={
          question.type === 'Multiple Select'
            ? () => {
                onSubmit();
                trackEvent(
                  EventCategories.POST_JOB_MODAL,
                  `Press Answer - ${question.name}`,
                  category
                );
              }
            : () => {
                trackEvent(
                  EventCategories.POST_JOB_MODAL,
                  `Press Answer - ${question.name}`,
                  category
                );
              }
        }
        selectedCategory={selectedCategory}
      />
      <Button
        primary
        block
        type={'submit'}
        m={0.5}
        style={answered ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={`${answered ? EventActions.PRESS_NEXT : EventActions.PRESS_SKIP} ${
          question.name
        }`}
        data-ga-label={category}
      >
        {answered ? 'Next' : 'Skip'}
      </Button>
    </Card>
  </Form>
);

QuestionStep.propTypes = {
  question: PropTypes.object,
  onSubmit: PropTypes.func,
  answered: PropTypes.bool,
  selectedCategory: CategoryType,
  category: PropTypes.string
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(QuestionStep);

export default connect()(ConnectedStep);
